import { Injectable } from '@angular/core';
import { BaseService } from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PurgrpService extends BaseService{
  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/purgrp';

  getUrl(): string {
    return this.url;
  }
}
